/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectAllApplication = (state: { application: any }) => state.application.applications;
export const selectNoApplication = (state: { application: any }) => state.application.noApplication;
export const selectSelectedApplication = (state: { application: any }) => state.application.selectedApplication;
